<template>
  <th :class="classes" class="px-2 text-left text-secondary-100">
    <slot />
  </th>
</template>

<script>
import TableData from './TableData.vue'

export default {
  mixins: [TableData],
}
</script>
